import React,{useState, useEffect, useRef} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { officials,associatiolistpublic,mailsend , schoolPublicurl,sportsPublicurl} from "../../apis/urls";
import { $ } from "react-jquery-plugin";
import { Multiselect } from "multiselect-react-dropdown";
import { decode } from "html-entities";
const RegisterFormOfficials = () => {
    document.body.classList.remove("new-login-wrpr");
    useEffect( ()=>{
      
        schoolListing();
        $('body').removeClass('').addClass('sidebar-collapsed');
        $('.sidebar-toggler').removeClass('sidebar-toggler').addClass('sidebar-toggler-remove');
    },[])
    useEffect( ()=>{
        sportsListing();
       
    },[])

    const role = localStorage.getItem('userrole')

    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [title, setTitle] = useState('');
    const [email, setEmail] = useState('');
    const [wphone, setWhone] = useState('');
    const [school, setSchool] = useState('');
    const [sport, setSport] = useState('');
    const [status, setStatus] = useState('');
    const [res, setRes] = useState([]);
    const [result, setResult] = useState([]);
    const [ offic, setOffic ] = useState([]);
    const [sports_id, setSports_id] = useState([]);

    const [fnameerror,setFnameerror] = useState(false);
    const [titleerror,setTitleerror] = useState(false);
	const [workphoneerror,setWorkPhoneError] = useState(false);
	const [emailerror,setEmailError] = useState(false);


    const firstRender = useRef(true);
    const [disable, setDisabled] = useState(true);
    const [emailvaliderror, setEmailValidErrors] = useState(null);
    const [emailExistError, setEmailExistError] = useState(null);
    const [phonevalidError, setPhoneValidError] = useState(null);
    const [schoolError, setSchoolError] = useState(null);
    const[sportError,setSportserror] =  useState(null);

    const username = localStorage.getItem('username')
    useEffect(() => {
        if (firstRender.current) {
          firstRender.current = false;
          return;
        }
    
    const formValidation = () => {
        const emailValidation = !/\S+@\S+\.\S+/.test(email);
          if (emailValidation) {
            setEmailValidErrors("Email address is invalid");
          } else {
            setEmailValidErrors(null);
          }
        };
       setDisabled(formValidation());

       

       const formPhoneValidation = () => {
           
          const phoneValidation =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

          if((wphone.match(phoneValidation))){
         // if (phoneValidation) {
            setPhoneValidError(null);
          } else {
            setPhoneValidError("Phone number is invalid");
          }
        };
        setDisabled(formPhoneValidation());

        // const formZipValidation = () => {
        //     const zipValidation =  /^\d{6}(-\d{4})?$/.test(zip);
        //     if (zipValidation) {
        //       setZipValidError(null);
        //     } else {
        //         setZipValidError("Zip is invalid");
        //     }
        //   };
          //setDisabled(formZipValidation());     



      }, [email, wphone]);


    let navigate = useNavigate();

    const schoolListing = ()=>{
        
        const instance = axios.create({
            baseURL: schoolPublicurl,
            timeout: 1000000
             
          });
    
          instance.get('').then(res => {

            setRes(res.data.data);
            console.log("datas", res.data.data);    

        }).catch((error) =>{
            console.log('error',"failed in schoool")
           

        });;
    }

    const sportsListing = ()=>{

   
        
        const instance = axios.create({

            baseURL: sportsPublicurl,

            timeout: 1000000,

            

          });
          
          instance.get('').then((res1) =>{

            console.log("resposne data is",res1.data.data);
            
            setResult(res1.data.data);
            
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });


    }

    let sportsArray = []


    const handleSelect = (id) => {
        // setSchool_id(id)
            id?.map((item,index) => {
                sportsArray.push(item.id)
            }
            
            )
            setSports_id(sportsArray)
            console.log(sportsArray)
            return sportsArray;
    };


    
    const handleRemove = (id) => {
        id?.map((item,index) => {
            sportsArray.push(item.id)
        }
        )

        setSports_id(sportsArray)

    };

    const onCreateOfficial =()=> {

console.log("hii"); 
        let error = 0;

		if(fname === '')
		{
			setFnameerror(true)
			error =1;
		}
		else
		{
			setFnameerror(false)
		}

        // if(title === '')
		// {
		// 	setTitleerror(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setTitleerror(false)
		// }
        
        if(email === '')
		{
			setEmailError(true)
			error =1;
		}
		else
		{
			setEmailError(false)
		}
        // if(wphone === '')
		// {
		// 	setWorkPhoneError(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setWorkPhoneError(false)
		// }

        if(school === '')
		{
			setSchoolError(true)
			error =1;
		}
		else
		{
			setSchoolError(false) 
		}
        console.log(error);
        if(error === 0)
        {
console.log(sports_id);
            let token = "Bearer "+localStorage.getItem('token');
            //console.log(token)
            const data = {
                sports :sports_id, 
                firstname :fname,
                lastname :lname, 
                email:email, 
                work_phone:wphone,
                school_id:school,
                status :'ACTIVE'
            }
            console.log('datas in header',data)
            
            const instance = axios.create({

                baseURL: officials+"public",

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{

                // console.log('officials',response.data.data.firstname)

                setOffic(response.data.data)


                alert("An email has been sent to your registered email address with your Username and Password to login and take the test.")
                let user_name ='';
                if(role === 'HO_SCHOOL')
                {

                    window.location.reload()
                    user_name = username;

                }else{
                    user_name='self'

                    navigate("/coaches")
                }


                // MAIL SENDING for Admin


					// let token = "Bearer "+localStorage.getItem('token');
					// console.log(token)
					// const data = {
					// 	name: 'Praveen',
					// 	current_login:user_name,
					// 	official_name:response.data.data.firstname
						
						
					// }
                    // //console.log('maildata',data)
					
					// const instance = axios.create({

					// 	baseURL: mailsend+'/officialAdminmail',

					// 	timeout: 1000000,

					// 	headers: {'authorization': token}

					// });
					
					// instance.post('',data).then((response) =>{
					// 	console.log("mail send successfully")

					// }).catch((error) =>{
						
					// console.log('error in sending',error)

					// });

                // END MAIL SENDING 
                
                
            
            }).catch((error) =>{
                console.log('error',error.message)
                console.log(error.response.data.error[0].email)
                setEmailExistError(error.response.data.error[0].email)

            });

        }


        
    }
   

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Register</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    {/* <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            
                                <li className="breadcrumb-item"><Link to="/associations"> Association List</Link></li>
                           
                            <li className="breadcrumb-item"><Link to={"/officials/"+id}>Official List</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Official</li>
                        </ol>
                    </nav> */}


                    <form className="needs-validation">
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label >Sports<span style={{color: "red"}}>*</span></label>		
                                            {/*<input type="text" value={title} onChange={e => {setTitle(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Title" /> */ }
                                            { /* 
                                               titleerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Title</div>:null
                                            */}
                                             { /* <select value={sport} onChange={e => {setSport(e.target.value)}} class="form-control bg-dark selctbx" id="asso">
                                            <option value=''>Select Sports</option>
                                            {
                                                result?.map((item,index)=>(
                                                    <option key={index} selected value={item.id}>{item.name}</option>

                                                ))
                                            }
                                            
                                            
                                        
                                                                                    
                                        </select> */ }

                                        <Multiselect
                                        placeholder={sports_id?.length===0?"You can select multiple sports":"Select"}
                                        options={decode(result)}
                                        value={decode(sportsArray)}
                                        onSelect={handleSelect}
                                        onRemove={handleRemove} 
                                        displayValue="name" />
                                    {
                                        sportError? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Select Sports</div>:null

                                    }

                                        </div>

                                        <div class="col-md-4">
                                            <label>School<span style={{color: "red"}}>*</span> </label>
                                            <select  value={school} onChange={e => {setSchool(e.target.value)}} class="form-control bg-dark selctbx" id="asso">
                                                    <option value=''>Select School</option>
                                                    {
                                                        res?.map((item,index)=>(
                                                            <option key={index} selected value={item.id}>{decode(item.name)}</option>

                                                        ))
                                                    }
                                                
                                                                                            
                                            </select>
                                            {
                                                schoolError? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Select School</div>:null

                                            }



                                        </div>

                                        <div className="col-md-4">
                                            <label >First Name<span style={{color: "red"}}>*</span></label>
                                            <input type="text" value={fname} onChange={e => {setFname(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter First Name" />
                                            {
                                                fnameerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter First Name</div>:null
                                            }
                                        </div>

                                        
                                         
                                    </div>
                                </div>
                                
                               

                               
                                <div className="form-group">
                                    <div className="row"> 

                                        <div className="col-md-4">
                                            <label >Last Name<span style={{color: "red"}}>*</span></label>		
                                            <input type="text" value={lname} onChange={e => {setLname(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Last Name" />
                                        </div>
                                       
                                        <div className="col-md-4">
                                            <label >Email<span style={{color: "red"}}>*</span></label>		
                                            <input type="email" value={email} onChange={e => {setEmail(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Email" />
                                            {
                                                emailerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Email</div>
                                                : <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailvaliderror && <p>{emailvaliderror}</p>}</div>
                                            }
                                            {
                                                emailExistError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailExistError && <p>{emailExistError}</p>}</div> :null
                                            }

                                        </div> 

                                        <div className="col-md-4"> 
                                            <label >Phone<span style={{color: "red"}}></span></label>
                                            <input type="text" value={wphone} onChange={e => {setWhone(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Phone Number" />
                                            {/*
                                                workphoneerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Work Phone</div>
                                                :<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{phonevalidError && <p>{phonevalidError}</p>}</div>
                                        */ }
                                        </div>

                                       


                                    </div>
                                </div>

                

                                <div className="form-group text-right ">
                                
                                <button className="btn btn-primary btn-gisa" onClick={onCreateOfficial} type="button">Register </button>
                                </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </aside>
        </div>
    )
}

export default RegisterFormOfficials;
